import { render, staticRenderFns } from "./shandong-khcenter.vue?vue&type=template&id=0d304e2a&scoped=true&"
import script from "./shandong-khcenter.vue?vue&type=script&lang=js&"
export * from "./shandong-khcenter.vue?vue&type=script&lang=js&"
import style0 from "./shandong-khcenter.vue?vue&type=style&index=0&id=0d304e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d304e2a",
  null
  
)

export default component.exports